import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo, } from 'react';
const TextLinkButton = ({ children, className, disabled = false, onClick, submit = false, }) => (_jsx("button", Object.assign({ className: className, disabled: disabled, onClick: disabled
        ? undefined
        : onClick, type: submit
        ? 'submit'
        : 'button' }, { children: children })));
const MemoizedTextLinkButton = memo(TextLinkButton);
export { MemoizedTextLinkButton as TextLinkButton };
// MC-1068 Temporary hack for Storybook.
export default TextLinkButton;
